import { render, staticRenderFns } from "./ServiceResourceGroup.vue?vue&type=template&id=3ed2bb21&"
import script from "./ServiceResourceGroup.vue?vue&type=script&lang=js&"
export * from "./ServiceResourceGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports